import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  IconFirstAidKit,
  IconAlertOctagon,
  IconScale,
  IconCompass,
} from '@tabler/icons-react';
import { useMingo } from '../context/MingoContext';
import { canEnterMainApp } from '../lib/onboardingStorage';

const TYPES = [
  { id: 'medical', Icon: IconFirstAidKit },
  { id: 'scam', Icon: IconAlertOctagon },
  { id: 'legal', Icon: IconScale },
  { id: 'lost', Icon: IconCompass },
];

/** Global floating SOS — types are quick intents; full contacts on emergency page. */
function SOSButton() {
  const { t, showToast } = useMingo();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  if (!canEnterMainApp()) return null;
  if (location.pathname.startsWith('/splash') || location.pathname.startsWith('/onboarding/')) return null;
  if (location.pathname !== '/settings/account') return null;

  function onPick(id) {
    setOpen(false);
    showToast(t('expansion.sosToast', { type: t(`expansion.sosType.${id}`) }));
    navigate(`/emergency-contacts?sos=${encodeURIComponent(id)}`);
  }

  return (
    <>
      <button
        type="button"
        className="mingo-sos-fab"
        aria-label={t('expansion.sosFab')}
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        SOS
      </button>
      {open ? (
        <div className="mingo-sos-root" role="presentation">
          <button type="button" className="mingo-sos-backdrop" aria-label={t('common.close')} onClick={() => setOpen(false)} />
          <div className="mingo-sos-sheet" role="dialog" aria-modal="true" aria-label={t('expansion.sosSheetTitle')}>
            <p className="mingo-sos-sheet__title">{t('expansion.sosSheetTitle')}</p>
            <ul className="mingo-sos-sheet__list">
              {TYPES.map((x) => (
                <li key={x.id}>
                  <button type="button" className="mingo-sos-sheet__btn" onClick={() => onPick(x.id)}>
                    <span aria-hidden="true" style={{ display: 'inline-flex', verticalAlign: 'middle', marginRight: 6 }}>
                      <x.Icon size={18} stroke={2} aria-hidden />
                    </span>{' '}
                    {t(`expansion.sosType.${x.id}`)}
                  </button>
                </li>
              ))}
            </ul>
            <p className="mingo-sos-sheet__hint">{t('expansion.sosHint')}</p>
          </div>
        </div>
      ) : null}
    </>
  );
}

export default SOSButton;
